// extracted by mini-css-extract-plugin
export default {"dialogContent":"UGNuzUimwCPtS7U0idlM","errorLink":"kJcFhXcjZYS_HsIellws","errorButton":"FaRo156KY1B5Vo8h_CtF"};